var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgW5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1638_3661)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.8273 23.057C39.6894 25.5678 38.9512 28.0089 37.6747 30.1754C36.3981 32.3419 34.6205 34.1705 32.491 35.5078L20.9625 41.9219L9.43398 35.5078C7.3045 34.1705 5.52689 32.3419 4.25034 30.1754C2.9738 28.0089 2.23559 25.5678 2.09766 23.057V6.28828C9.18245 6.28828 15.7223 3.94066 20.9625 0C26.2027 3.96162 32.7425 6.28828 39.8273 6.28828V23.057ZM20.9625 25.3208L27.0831 29.5968L24.9241 22.4492L30.877 17.9426L23.4149 17.7749L20.9625 10.732L18.5101 17.7749L11.048 17.9426L16.9799 22.4282L14.8209 29.5549L20.9625 25.3418V25.3208Z",
    fill: "#007AFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1638_3661"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41.9219,
    height: 41.9219,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgW5);
export default __webpack_public_path__ + "static/media/w5.50af567da7988111eb43c683c7b8d81c.svg";
export { ForwardRef as ReactComponent };